





























import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import {BModal, VBModal, BButton} from 'bootstrap-vue';
import {
	ConvertModule,
	IBudget,
	IIncentive,
	IIncentiveCategory,
	ILocation
} from '@/stores/modules/convert';
import {find, findIndex, remove} from 'lodash';
import CampaignModal from '@/components/CampaignModal.vue';
import {WebService} from '@/services/web.service';
import ConvertIcon from '../assets/icon-convert.svg';
import IncreaseIcon from '../assets/icon-increase.svg';
import AwardIcon from '../assets/icon-award.svg';
import moment from 'moment';

@Component({
	components: {
		'b-modal': BModal,
		'b-button': BButton,
		CampaignModal: CampaignModal,
		ConvertIcon: ConvertIcon,
		IncreaseIcon: IncreaseIcon,
		AwardIcon: AwardIcon
	},
	directives: {
		'b-modal': VBModal
	}
})
export default class AutomatedAIMarketing extends Vue {
	@Prop(String)
	base: string | undefined;

	programId: string | null = null;

	get campaigns() {
		if(this.base === undefined) {
			return [];
		}
		return ConvertModule.campaignsByLocationBase(this.base);
	}

	get location() {
		console.log('BASE: ', this.base);
		if(this.base === undefined) {
			return null;
		}
		return ConvertModule.locationByBase(this.base);
	}


	getTimeSince(timestamp: number) {
		return moment.unix(timestamp).fromNow(true);
	}


	async showModal(programId: string) {
		this.programId = programId;
		this.$bvModal.show('campaign-modal');
	}

	async mounted() {
		await WebService.getLocations();
		await WebService.getCampaigns(this.base as string);
	}

	modalClosed() {
		this.programId = null;
	}

	// TODO: Remove this once everything is implemented
	alert(message: string) {
		alert(message);
	}
}
